function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyPersonal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "My personal info",
    d: "M683 368a11.981 11.981 0 1 0 12 12 12.013 12.013 0 0 0-12-12zm0 22a9.966 9.966 0 0 1-7.091-2.958 8.242 8.242 0 0 1 14.182 0A9.963 9.963 0 0 1 683 390zm-3-12a3 3 0 1 1 3 3 3 3 0 0 1-3-3zm11.413 7.385a9.973 9.973 0 0 0-4.96-3.784 5 5 0 1 0-6.906 0 9.973 9.973 0 0 0-4.96 3.784 10 10 0 1 1 16.826 0z",
    transform: "translate(-671 -368)",
    style: {
      fill: "#175664"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPersonal);
export default __webpack_public_path__ + "static/media/MyPersonal.36c5abf6.svg";
export { ForwardRef as ReactComponent };